import { useRouteTranslation } from '@/hooks/useRouteTranslation'

export default function WelcomeMessage() {
  const { t } = useRouteTranslation()
  return (
    <div>
      {/* Welcome Message Section Container */}
      <div className="container mx-auto px-4 max-w-7xl">
        {/* Welcome to Islam Section */}
        <div className="max-w-5xl mx-auto">
          <div
            className="rounded-2xl bg-gradient-to-br from-[#01B87A] to-[#059669] p-6 text-white dark:from-green-800 dark:to-green-900 md:p-10"
            style={{ borderRadius: '20px', boxShadow: '0 10px 24px rgba(16, 24, 40, 0.10)', border: '1px solid rgba(16, 24, 40, 0.04)' }}
          >
            {/* Main Heading */}
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 md:mb-6 leading-relaxed text-center" style={{ fontWeight: 700 }}>
              {t('journey.welcome.heading', 'أهلاً بك في الإسلام')}
              <br />
              {t('journey.welcome.headingSub', 'دين الرحمة والسلام')}
            </h2>

            {/* Welcome Message */}
            <div className="space-y-3 md:space-y-4 text-sm md:text-base lg:text-lg leading-relaxed">
              <p className="font-medium">
                {t('journey.welcome.para1', 'الحمد لله الذي هداك إلى هذا الطريق المبارك. إن اختيارك للإسلام هو أعظم قرار في حياتك، وبداية رحلة روحانية مليئة بالسكينة والطمأنينة.')}
              </p>

              <p>
                {t('journey.welcome.para2', 'الإسلام ليس مجرد دين، بل هو منهج حياة كامل يجمع بين راحة القلب وصلاح الدنيا والآخرة. هو دين الفطرة الذي يتوافق مع العقل والمنطق، ويملأ القلب بالسلام الداخلي.')}
              </p>

              <p>
                {t('journey.welcome.para3', 'في الإسلام، أنت في علاقة مباشرة مع الله، لا وسيط بينك وبينه. يمكنك أن تدعوه في أي وقت، وأن تناجيه بما في قلبك، وأن تطلب منه المغفرة والهداية.')}
              </p>

              {/* Quranic verse */}
              <div className="my-6 md:my-8 text-center">
                <p className="font-bold text-lg md:text-xl lg:text-2xl mb-2 leading-relaxed">
                  &quot;وَمَنْ أَحْسَنُ قَوْلًا مِّمَّن دَعَا إِلَى اللَّهِ وَعَمِلَ صَالِحًا وَقَالَ إِنَّنِي مِنَ الْمُسْلِمِينَ&quot;
                </p>
                <p className="text-xs md:text-sm opacity-90">
                  (سورة فصلت: 33)
                </p>
              </div>

              {/* Closing Message */}
              <p className="text-sm md:text-base lg:text-lg leading-relaxed">
                {t('journey.welcome.closing', 'مرحبًا بك في عائلتك الجديدة - أمة الإسلام. أكثر من مليار ونصف مسلم حول العالم يشاركونك نفس الإيمان ويدعون الله أن يثبتك ويوفقك في طريقك الجديد')}
              </p>

              {/* Final Blessing */}
              <p className="mt-4 md:mt-6 text-lg md:text-xl font-bold text-center">
                {t('journey.welcome.blessing', 'بارك الله فيك وهداك إلى ما يحب ويرضى 🤲')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

